import { ReactNode } from 'react';

export type ModalProps = {
  children: ReactNode;
  modalStyle?: string;
  headerStyle?: string;
  isOpen: boolean;
  onClose: () => void;
  position?: ModalPositions;
  fullScreen?: boolean;
};

export enum ModalPositions {
  CENTER = 'center',
  TOP = 'top',
  BOTTOM = 'bottom',
  LEFT = 'left',
  RIGHT = 'right',
  TOP_LEFT = 'top-left',
  TOP_RIGHT = 'top-right',
  BOTTOM_LEFT = 'bottom-left',
  BOTTOM_RIGHT = 'bottom-right',
}
